import { yupResolver } from '@hookform/resolvers/yup';
import { ChevronLeftIcon, EnterIcon } from '@radix-ui/react-icons';
import { Button, Card, Flex, Spinner } from '@radix-ui/themes';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import TextFieldComponent from '../../components/inputs/Textfield/TextfieldComponent';
import { routes } from '../../routes';
import { createTeacherRequiredDocument } from '../../services/school/teacher/createTeacherRequiredDocument';
import { RulesDocumentTeacherType } from '../../types/Teacher';
import { CreateTeacherRequiredDocumentFormValidation } from './CreateTeacherRequiredDocumentFormValidation';
export const CreateTeacherRequiredDocument= ()=> {
  const navigate = useNavigate();
  const mutation = useMutation({ mutationFn: (createTeacherRequiredDocument), mutationKey: 'createTeacherRequiredDocument' });
  const { control, handleSubmit, formState: { errors } } = useForm<RulesDocumentTeacherType>
    (
      {
        resolver: yupResolver(CreateTeacherRequiredDocumentFormValidation),
        defaultValues: {
          description: ''
        },
        mode: 'onBlur',
        reValidateMode: 'onBlur',
        shouldUseNativeValidation: false,
      }
    );

  const onSubmit = handleSubmit(async (data) => {
    try {
      const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success("Tipo de documento criado");
        navigate(routes.teacherRequiredDocuments);
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });
  const handleBack = () => {
    navigate(routes.teacherRequiredDocuments);
  }
  return (

    <form onSubmit={onSubmit} noValidate>
      <Card size='1'>
        <Flex direction='column' gap='4'>
          <TextFieldComponent control={control} errors={errors} label='Tipo de documento' name='description' style={{ width: "100%" }} required={true}/>
          <Flex direction='row' gap='3' justify='end'>
            <Button type="button" variant='soft' color='gray' onClick={handleBack} disabled={mutation.isLoading}>
              <ChevronLeftIcon /> Voltar
            </Button>
            <Button type="submit" disabled={mutation.isLoading}>
              {mutation.isLoading ? <Spinner /> : <EnterIcon />}
              Registar
            </Button>
          </Flex>
        </Flex>
      </Card>
    </form>
  );
}